import { useTheme } from "@repo/tokens";
import { VStack, Text, Lottie, animations } from "@repo/ui";
import { TestModal } from "../TestModal";
import { useTranslation } from "react-i18next";

import { createStyles } from "./styles";
import type { ExamSubmissionProps } from "./types";
import cssStyles from "./ExamSubmission.module.scss";

export const ExamSubmission = ({
  isOpen,
  onClose,
  title,
  description,
}: ExamSubmissionProps) => {
  const { t } = useTranslation("tests");
  const { theme } = useTheme();
  const styles = createStyles(theme);

  const renderBody = () => {
    return (
      <VStack
        align="center"
        gap="xl"
        className={cssStyles.content}
        width="100%"
      >
        <Lottie
          loop={true}
          width={108}
          height={108}
          autoPlay={true}
          animation={animations.blueLoader}
        />

        <Text style={styles.title}>{title ?? t("exam_submission_title")}</Text>

        <Text color={theme.colors.neutral[20]} style={styles.description}>
          {description ?? t("exam_submission_in_progress")}
        </Text>
      </VStack>
    );
  };

  return (
    <TestModal
      isOpen={isOpen}
      onClose={onClose}
      body={renderBody()}
      isOverlay={true}
      width="min(95vw, 40rem)"
    />
  );
};
